import { Quill } from "@vueup/vue-quill";

let BlockEmbed = Quill.import("blots/block/embed");

class AudioBlot extends BlockEmbed {
  static create(value) {
    let node = super.create();
    node.setAttribute("alt", value.alt);
    node.setAttribute("src", value.url);
    node.setAttribute("controls", "controls");
    node.setAttribute("controlsList", "nodownload");
    node.setAttribute("preload", true);
    return node;
  }

  static value(node) {
    return {
      alt: node.getAttribute("alt"),
      url: node.getAttribute("src"),
    };
  }
}

AudioBlot.blotName = "audio";
AudioBlot.tagName = "audio";

export default AudioBlot;
